import { Component, OnInit } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';
import { EventsService } from 'src/app/services/event/event.service';

@Component({
  selector: 'app-migration-success',
  templateUrl: './migration-success.component.html',
  styleUrls: ['./migration-success.component.scss'],
})
export class MigrationSuccessComponent implements OnInit {

  constructor(
    private navigator: Navigator,
    private eventService: EventsService
  ) { }

  ngOnInit() {}

  onContinue(){
    this.navigator.dismiss();
    this.eventService.publish('show:welcome:dialog');
  }

}
